import axios from "axios";
import { idleExpired } from "./staffIdle";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function apiErrorMessage(error, fallback = "Something went wrong") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => item?.msg || item?.message).filter(Boolean);
    if (messages.length) return messages.join("; ");
  }
  if (detail && typeof detail === "object") return detail.message || detail.error || fallback;
  return error?.message || fallback;
}

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((cfg) => {
  const authenticationRequest = ["/auth/login", "/auth/logout", "/auth/google/session"].includes(cfg.url);
  if (!authenticationRequest && idleExpired()) {
    window.dispatchEvent(new Event("mg-session-expired"));
    throw new axios.CanceledError("Staff session expired. Sign in again before retrying.");
  }
  const token = sessionStorage.getItem("mg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const branchId = sessionStorage.getItem("mg_branch_id");
  if (branchId) cfg.headers["X-Branch-ID"] = branchId;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const config = err?.config;
    const isTransientNetworkFailure = !err?.response && config && !axios.isCancel(err);
    const isSafeRequest = String(config?.method || "get").toLowerCase() === "get";
    if (isTransientNetworkFailure && isSafeRequest && (config.__networkRetryCount || 0) < 2) {
      config.__networkRetryCount = (config.__networkRetryCount || 0) + 1;
      await new Promise((resolve) => setTimeout(resolve, config.__networkRetryCount * 250));
      return api(config);
    }
    if (err?.response?.status === 401) {
      if (!["/auth/login", "/auth/logout"].includes(config?.url)) {
        window.dispatchEvent(new Event("mg-session-expired"));
      }
      // Don't redirect from public routes
      const path = window.location.pathname;
      if (!["/", "/login", "/register"].includes(path) && !path.startsWith("/clinic/")) {
        // soft handling: keep user, AuthProvider will redirect
      }
    }
    return Promise.reject(err);
  }
);

export default api;
